
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $dab026e6ef7c0749$exports = {};

$parcel$export($dab026e6ef7c0749$exports, "load", function () { return $dab026e6ef7c0749$export$11e63f7b0f3d9900; });
$parcel$export($dab026e6ef7c0749$exports, "play", function () { return $dab026e6ef7c0749$export$899fbdb5fa08b653; });
$parcel$export($dab026e6ef7c0749$exports, "audioBuffers", function () { return $dab026e6ef7c0749$export$c2a342ec653dfb48; });
// Manages loading, decoding and plaback of audioBuffers

// References
const $dab026e6ef7c0749$export$c2a342ec653dfb48 = {};
function $dab026e6ef7c0749$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            if (request.status !== 200) {
                reject();
                console.error(`An error occured while getting '${name}' audio from '${url}', status: ${request.status}`);
                return;
            }
            resolve($dab026e6ef7c0749$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $dab026e6ef7c0749$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $85faba1dc2985ba6$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $dab026e6ef7c0749$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
async function $dab026e6ef7c0749$export$899fbdb5fa08b653(name, options = {}) {
    if ($dab026e6ef7c0749$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    await $85faba1dc2985ba6$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $85faba1dc2985ba6$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $85faba1dc2985ba6$export$a078c61943f9dbbe.createGain();
    if (options.gain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($85faba1dc2985ba6$export$33ed28de027e9482(options.gain), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $85faba1dc2985ba6$export$549ee30ac73cf40b; // custom function
    source.fade = $85faba1dc2985ba6$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $85faba1dc2985ba6$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $dab026e6ef7c0749$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $85faba1dc2985ba6$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer !== true) source.start(when, offset, duration);
    // Maintain references to this source
    $85faba1dc2985ba6$export$d1d41f0cda037248.push(source);
    return source;
}


var $71fc55f3cf0c7f08$exports = {};

$parcel$export($71fc55f3cf0c7f08$exports, "createPanner", function () { return $71fc55f3cf0c7f08$export$604289ae06b8fa82; });
$parcel$export($71fc55f3cf0c7f08$exports, "positionListener", function () { return $71fc55f3cf0c7f08$export$f0551cbb67220cad; });
$parcel$export($71fc55f3cf0c7f08$exports, "orientListener", function () { return $71fc55f3cf0c7f08$export$27298482267e128c; });
$parcel$export($71fc55f3cf0c7f08$exports, "play", function () { return $71fc55f3cf0c7f08$export$899fbdb5fa08b653; });
// Manages audiospatialisation

function $71fc55f3cf0c7f08$export$604289ae06b8fa82(options = {}) {
    const panner = $85faba1dc2985ba6$export$a078c61943f9dbbe.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "exponential";
    panner.refDistance = 1;
    panner.maxDistance = 20;
    panner.rolloffFactor = 2;
    // panner.coneInnerAngle = 360;
    // panner.coneOuterAngle = 0;
    // panner.coneOuterGain = 0;
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        panner.orientationY.setValueAtTime(0, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        panner.orientationZ.setValueAtTime(-1, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    } else panner.setOrientation(0, 0, -1);
    panner.positionPanner = function(x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
            panner.positionY.setValueAtTime(y, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
            panner.positionZ.setValueAtTime(z, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        } else panner.setPosition(x, y, z);
    };
    panner.connect(options.destination || $85faba1dc2985ba6$export$a078c61943f9dbbe.destination);
    return panner;
}
function $71fc55f3cf0c7f08$export$f0551cbb67220cad(x, y, z) {
    const listener = $85faba1dc2985ba6$export$a078c61943f9dbbe.listener;
    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.positionY.setValueAtTime(y, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.positionZ.setValueAtTime(z, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    } else listener.setPosition(x, y, z);
}
function $71fc55f3cf0c7f08$export$27298482267e128c(direction) {
    // Orient the listener in the direction of the player
    // The direction is given in degrees (0 to 360) in a 2d ground plane
    // Facing the screen is 0, facing right is 90, facing left is -90
    // FIXME: There is no up/down orientation implemented yet
    const deltaAngleX = Math.abs(direction + 90) % 360;
    const deviationX = deltaAngleX < 180 ? deltaAngleX : 360 - deltaAngleX;
    const deltaAngleZ = Math.abs(direction) % 360;
    const deviationZ = deltaAngleZ < 180 ? deltaAngleZ : 360 - deltaAngleZ;
    const fx = deviationX / 180 * 2 - 1;
    const fy = 0;
    const fz = deviationZ / 180 * 2 - 1;
    const ux = 0;
    const uy = 1;
    const uz = 0;
    const listener = $85faba1dc2985ba6$export$a078c61943f9dbbe.listener;
    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.forwardY.setValueAtTime(fy, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.forwardZ.setValueAtTime(fz, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.upX.setValueAtTime(ux, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.upY.setValueAtTime(uy, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
        listener.upZ.setValueAtTime(uz, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    } else listener.setOrientation(fx, fy, fz, ux, uy, uz);
}
function $71fc55f3cf0c7f08$export$899fbdb5fa08b653(p) {
    // p for POI
    const panner = $71fc55f3cf0c7f08$export$604289ae06b8fa82();
    panner.positionPanner(p.position.x, p.position.z, p.position.y);
    p.sound.panner = panner;
    $dab026e6ef7c0749$exports.play(p.sound.name, {
        // TODO: this should probably merged with defaults in buffers.js
        gain: p.sound.gain || 0,
        loop: p.sound.loop || true,
        when: p.sound.when || 0,
        destination: panner,
        defer: p.sound.defer
    }).then((source)=>{
        p.sound.source = source;
    });
}


// References
let $85faba1dc2985ba6$export$a078c61943f9dbbe;
const $85faba1dc2985ba6$export$d1d41f0cda037248 = [];
function $85faba1dc2985ba6$export$2cd8252107eb640b() {
    // Create AudioContext
    $85faba1dc2985ba6$export$a078c61943f9dbbe = new AudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $85faba1dc2985ba6$export$a078c61943f9dbbe.sampleRate);
}
function $85faba1dc2985ba6$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($85faba1dc2985ba6$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $85faba1dc2985ba6$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $85faba1dc2985ba6$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($85faba1dc2985ba6$export$33ed28de027e9482(fromLevel), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($85faba1dc2985ba6$export$33ed28de027e9482(level), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($85faba1dc2985ba6$export$33ed28de027e9482(level), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $85faba1dc2985ba6$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $85faba1dc2985ba6$export$33ed28de027e9482(db), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $85faba1dc2985ba6$export$33ed28de027e9482(db), $85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($85faba1dc2985ba6$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $85faba1dc2985ba6$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $85faba1dc2985ba6$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $85faba1dc2985ba6$export$33390c3a9a83a2f() {
    $85faba1dc2985ba6$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $85faba1dc2985ba6$export$93c25f2590a5b540(source) {
    const index = $85faba1dc2985ba6$export$d1d41f0cda037248.indexOf(source);
    $85faba1dc2985ba6$export$d1d41f0cda037248.splice(index, 1);
}
function $85faba1dc2985ba6$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $85faba1dc2985ba6$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}







// Convert world direction to radians
function $746fd1397863c828$export$1ad3c7ead57ef8c(dir) {
    return dir * Math.PI / 180 - Math.PI / 2;
}
// Convert degrees to radians
function $746fd1397863c828$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}



const $294c1e0055589ac6$var$joystickEl = document.querySelector(".joystick");
const $294c1e0055589ac6$var$joystickSize = 60;
const $294c1e0055589ac6$export$d0b7ea69ab6056df = {
    active: false,
    startX: 0,
    startY: 0,
    xAxis: 0,
    yAxis: 0
};
function $294c1e0055589ac6$export$2cd8252107eb640b() {
    // Register touch events
    window.addEventListener("touchstart", (e)=>{
        $294c1e0055589ac6$export$d0b7ea69ab6056df.active = true;
        $294c1e0055589ac6$export$d0b7ea69ab6056df.startX = e.touches[0].clientX;
        $294c1e0055589ac6$export$d0b7ea69ab6056df.startY = e.touches[0].clientY;
        $294c1e0055589ac6$var$joystickEl.style.translate = `${$294c1e0055589ac6$export$d0b7ea69ab6056df.startX - $294c1e0055589ac6$var$joystickSize / 2}px ${$294c1e0055589ac6$export$d0b7ea69ab6056df.startY - $294c1e0055589ac6$var$joystickSize / 2}px`;
        $294c1e0055589ac6$var$joystickEl.style.opacity = 0.5;
    });
    window.addEventListener("touchmove", (e)=>{
        const halfJoy = $294c1e0055589ac6$var$joystickSize / 2;
        // Get touch move position
        let moveX = e.touches[0].clientX;
        let moveY = e.touches[0].clientY;
        // Calculate joystick delta
        let deltaX = moveX - $294c1e0055589ac6$export$d0b7ea69ab6056df.startX;
        let deltaY = moveY - $294c1e0055589ac6$export$d0b7ea69ab6056df.startY;
        // Calculate joystick distance
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
        // Constrain joystick to its size
        if (distance > halfJoy) {
            const angle = Math.atan2(deltaY, deltaX);
            deltaX = Math.cos(angle) * halfJoy;
            deltaY = Math.sin(angle) * halfJoy;
            moveX = $294c1e0055589ac6$export$d0b7ea69ab6056df.startX + deltaX;
            moveY = $294c1e0055589ac6$export$d0b7ea69ab6056df.startY + deltaY;
        }
        $294c1e0055589ac6$export$d0b7ea69ab6056df.xAxis = deltaX / halfJoy;
        $294c1e0055589ac6$export$d0b7ea69ab6056df.yAxis = deltaY / halfJoy;
        // Update joystick position
        $294c1e0055589ac6$var$joystickEl.style.translate = `${moveX - halfJoy}px ${moveY - halfJoy}px`;
    });
    window.addEventListener("touchend", (e)=>{
        $294c1e0055589ac6$export$d0b7ea69ab6056df.active = false;
        $294c1e0055589ac6$var$joystickEl.style.opacity = 0;
    });
}



let $a4a249b17eda019f$export$9fddb9d0dd7d8a54 = 0; // Degrees with 0 facing north, -Y on canvas
const $a4a249b17eda019f$export$5880b8b5730aff45 = {
    x: 0,
    y: 0,
    z: 1.8
};
const $a4a249b17eda019f$export$e506a1d27d1eaa20 = {
    maxVelocity: 2.5,
    acceleration: 4,
    damping: 4,
    controllable: true
};
const $a4a249b17eda019f$var$velocity = {
    x: 0,
    y: 0,
    z: 0,
    magnitude: 0,
    direction: 0
};
let $a4a249b17eda019f$var$accelerateX, $a4a249b17eda019f$var$accelerateY;
let $a4a249b17eda019f$export$ed594bb491455ccb = false;
function $a4a249b17eda019f$export$722fbec263ad908a(dt) {
    $a4a249b17eda019f$var$accelerateX = 0;
    $a4a249b17eda019f$var$accelerateY = 0;
    if ($a4a249b17eda019f$export$e506a1d27d1eaa20.controllable) {
        // Update player direction (Arrow Keys)
        if ($f07678ac589b406d$export$d081dc64f99d208b("ArrowLeft")) $a4a249b17eda019f$export$9fddb9d0dd7d8a54 -= 1;
        if ($f07678ac589b406d$export$d081dc64f99d208b("ArrowRight")) $a4a249b17eda019f$export$9fddb9d0dd7d8a54 += 1;
        $a4a249b17eda019f$export$9fddb9d0dd7d8a54 %= 360;
        // Update player velocity (Arrow Keys)
        if ($f07678ac589b406d$export$d081dc64f99d208b("ArrowUp")) $a4a249b17eda019f$var$accelerateY = -1;
        if ($f07678ac589b406d$export$d081dc64f99d208b("ArrowDown")) $a4a249b17eda019f$var$accelerateY = 1;
        // Update player direction (Mouse Y)
        // TODO: Implement mouse movement
        // Update player velocity (WASD)
        if ($f07678ac589b406d$export$d081dc64f99d208b("w")) $a4a249b17eda019f$var$accelerateY = -1;
        if ($f07678ac589b406d$export$d081dc64f99d208b("a")) $a4a249b17eda019f$var$accelerateX = -1;
        if ($f07678ac589b406d$export$d081dc64f99d208b("s")) $a4a249b17eda019f$var$accelerateY = 1;
        if ($f07678ac589b406d$export$d081dc64f99d208b("d")) $a4a249b17eda019f$var$accelerateX = 1;
        // Update player direction (Gamepad)
        // TODO: Implement gamepad movement
        // Update player velocity and rotation (Touch)
        if ((0, $294c1e0055589ac6$export$d0b7ea69ab6056df).active) {
            $a4a249b17eda019f$var$accelerateY = (0, $294c1e0055589ac6$export$d0b7ea69ab6056df).yAxis;
            $a4a249b17eda019f$export$9fddb9d0dd7d8a54 += (0, $294c1e0055589ac6$export$d0b7ea69ab6056df).xAxis;
        }
    }
    $a4a249b17eda019f$var$applyAcceleration(dt);
    $a4a249b17eda019f$var$applyVelocity(dt);
    // Update audio listener position
    (0, $71fc55f3cf0c7f08$export$f0551cbb67220cad)($a4a249b17eda019f$export$5880b8b5730aff45.x, $a4a249b17eda019f$export$5880b8b5730aff45.z, $a4a249b17eda019f$export$5880b8b5730aff45.y);
    // Update audio listener orientation
    (0, $71fc55f3cf0c7f08$export$27298482267e128c)($a4a249b17eda019f$export$9fddb9d0dd7d8a54);
}
function $a4a249b17eda019f$var$applyAcceleration(dt) {
    const accelerationDirection = Math.atan2($a4a249b17eda019f$var$accelerateY, $a4a249b17eda019f$var$accelerateX) + (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)($a4a249b17eda019f$export$9fddb9d0dd7d8a54);
    // Apply acceleration
    if ($a4a249b17eda019f$var$accelerateY || $a4a249b17eda019f$var$accelerateX) {
        $a4a249b17eda019f$var$velocity.x += Math.cos(accelerationDirection) * $a4a249b17eda019f$export$e506a1d27d1eaa20.acceleration * 2 * dt;
        $a4a249b17eda019f$var$velocity.y += Math.sin(accelerationDirection) * $a4a249b17eda019f$export$e506a1d27d1eaa20.acceleration * 2 * dt;
    }
}
function $a4a249b17eda019f$var$applyVelocity(dt) {
    // Calculate velocity magnitude
    $a4a249b17eda019f$var$velocity.magnitude = Math.sqrt($a4a249b17eda019f$var$velocity.x ** 2 + $a4a249b17eda019f$var$velocity.y ** 2);
    // Calculate velocity direction
    $a4a249b17eda019f$var$velocity.direction = Math.atan2($a4a249b17eda019f$var$velocity.y, $a4a249b17eda019f$var$velocity.x);
    // Limit velocity
    if ($a4a249b17eda019f$var$velocity.magnitude > $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity) {
        $a4a249b17eda019f$var$velocity.x = Math.cos($a4a249b17eda019f$var$velocity.direction) * $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity;
        $a4a249b17eda019f$var$velocity.y = Math.sin($a4a249b17eda019f$var$velocity.direction) * $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity;
        $a4a249b17eda019f$var$velocity.magnitude = $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity;
    }
    // Decelerate
    $a4a249b17eda019f$var$velocity.magnitude -= $a4a249b17eda019f$export$e506a1d27d1eaa20.damping * dt;
    if ($a4a249b17eda019f$var$velocity.magnitude < 0) $a4a249b17eda019f$var$velocity.magnitude = 0;
    $a4a249b17eda019f$var$velocity.x = Math.cos($a4a249b17eda019f$var$velocity.direction) * $a4a249b17eda019f$var$velocity.magnitude;
    $a4a249b17eda019f$var$velocity.y = Math.sin($a4a249b17eda019f$var$velocity.direction) * $a4a249b17eda019f$var$velocity.magnitude;
    // Add velocity to position
    $a4a249b17eda019f$export$5880b8b5730aff45.x += $a4a249b17eda019f$var$velocity.x * dt;
    $a4a249b17eda019f$export$5880b8b5730aff45.y += $a4a249b17eda019f$var$velocity.y * dt;
    $a4a249b17eda019f$export$5880b8b5730aff45.z += $a4a249b17eda019f$var$velocity.z * dt;
    // Constraint position to the worlds bounds
    const margin = 0.2;
    $a4a249b17eda019f$export$5880b8b5730aff45.x = Math.max($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.left + margin, Math.min($a4a249b17eda019f$export$5880b8b5730aff45.x, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.right - margin));
    $a4a249b17eda019f$export$5880b8b5730aff45.y = Math.max($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.top + margin, Math.min($a4a249b17eda019f$export$5880b8b5730aff45.y, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.bottom - margin));
    $a4a249b17eda019f$export$ed594bb491455ccb = $a4a249b17eda019f$export$5880b8b5730aff45.x === $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.left + margin || $a4a249b17eda019f$export$5880b8b5730aff45.x === $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.right - margin || $a4a249b17eda019f$export$5880b8b5730aff45.y === $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.top + margin || $a4a249b17eda019f$export$5880b8b5730aff45.y === $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.bottom - margin;
}
function $a4a249b17eda019f$export$e923c3a79e3a8606(dir) {
    $a4a249b17eda019f$export$9fddb9d0dd7d8a54 = dir;
}


const $555be16020503cc9$var$tweens = [];
const $555be16020503cc9$var$easingFunctions = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>t * (2 - t),
    easeInOutQuad: (t)=>t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>--t * t * t + 1,
    easeInOutCubic: (t)=>t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>1 - --t * t * t * t,
    easeInOutQuart: (t)=>t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>1 + --t * t * t * t * t,
    easeInOutQuint: (t)=>t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
};
function $555be16020503cc9$export$722fbec263ad908a(dt) {
    $555be16020503cc9$var$tweens.forEach((tween)=>tween.update(dt));
}
class $555be16020503cc9$export$208a41d6b4e37b97 {
    // TODO: return a promise that resolves when the tween ends ?
    constructor(from, to, duration, easingFunction = "linear", setFunction, callback){
        this.type = typeof from;
        if (this.type === "number") {
            this.from = from;
            this.to = to;
        } else if (this.type === "object") {
            this.target = from;
            this.from = {
                ...from
            };
            this.to = to;
        }
        this.duration = duration;
        this.time = 0;
        this.easingFunction = $555be16020503cc9$var$easingFunctions[easingFunction];
        this.setFunction = setFunction;
        this.ended = false;
        this.callback = callback || this.dispose;
        $555be16020503cc9$var$tweens.push(this);
    }
    update(dt) {
        this.time += dt;
        if (this.time > this.duration) {
            this.time = this.duration;
            if (typeof this.callback === "function" && !this.ended) this.callback(this);
            this.ended = true;
        }
        if (this.type === "object") for(const key in this.target)this.target[key] = $555be16020503cc9$var$lerp(this.from[key], this.to[key], this.easingFunction(this.time / this.duration));
        if (this.setFunction) {
            if (this.type === "object") this.setFunction({
                ...this.target
            });
            else this.setFunction(this.value());
        }
    }
    value() {
        return $555be16020503cc9$var$lerp(this.from, this.to, this.easingFunction(this.time / this.duration));
    }
    dispose() {
        $555be16020503cc9$var$tweens.splice($555be16020503cc9$var$tweens.indexOf(this), 1);
    }
}
function $555be16020503cc9$var$lerp(from, to, t) {
    return from + (to - from) * t;
}



const $14a6d3d86d620d4f$var$soundAssets = [];
const $14a6d3d86d620d4f$var$imageAssets = [];
const $14a6d3d86d620d4f$export$6c746a5570b8b35c = {};
function $14a6d3d86d620d4f$export$2cd8252107eb640b() {
    return Promise.all([
        $14a6d3d86d620d4f$var$loadSounds(),
        $14a6d3d86d620d4f$var$loadImages()
    ]);
}
function $14a6d3d86d620d4f$export$cb43b96ee3d96841(sounds) {
    $14a6d3d86d620d4f$var$soundAssets.push(...sounds);
}
function $14a6d3d86d620d4f$export$8250d5b41185d62d(images) {
    $14a6d3d86d620d4f$var$imageAssets.push(...images);
}
var $4bc8d6648d88142d$exports = {};
$4bc8d6648d88142d$exports = new URL("../bruit-de-fond.3bb7df54.wav", import.meta.url).toString();


function $14a6d3d86d620d4f$var$loadSounds() {
    return Promise.all([
        ...$14a6d3d86d620d4f$var$soundAssets.map((sound)=>{
            return $dab026e6ef7c0749$exports.load(sound.name, sound.url);
        }),
        $dab026e6ef7c0749$exports.load("bruit-de-fond", new URL($4bc8d6648d88142d$exports))
    ]).then(()=>{
        if (DEVMODE) console.log(`${$14a6d3d86d620d4f$var$soundAssets.length} sounds loaded`);
    });
}
function $14a6d3d86d620d4f$var$loadImages() {
    return Promise.all([
        ...$14a6d3d86d620d4f$var$imageAssets.map((image)=>{
            return new Promise((resolve, reject)=>{
                const img = new Image();
                img.onload = ()=>{
                    if (DEVMODE) console.log(`Image ${image.name} loaded`);
                    resolve();
                };
                img.onerror = ()=>{
                    reject(`Error loading image ${image.name}`);
                };
                img.src = image.url;
                $14a6d3d86d620d4f$export$6c746a5570b8b35c[image.name] = img;
                $14a6d3d86d620d4f$export$6c746a5570b8b35c[image.name].ppm = image.ppm;
            });
        })
    ]).then(()=>{
        if (DEVMODE) console.log(`${$14a6d3d86d620d4f$var$imageAssets.length} images loaded`);
    });
}








const $121c75b480798d23$var$POIs = [
    {
        name: "stonehenge-center",
        position: {
            x: 0,
            y: 0,
            z: 0
        },
        color: "hsl(0, 0%, 20%)",
        radius: 20,
        style: "idle",
        symbolic: false,
        collision: {
            radius: 1
        },
        onEnter () {
            if (this.style === "idle") return;
            $85faba1dc2985ba6$export$51b36263b660c3ee(); // TODO: This will not stop Grudge's whistles and will prevent restarting the game
            $dab026e6ef7c0749$exports.play("ding-final", {
                gain: 0
            });
            $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = false;
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)($a4a249b17eda019f$export$5880b8b5730aff45, this.position, 2, "easeOutQuad");
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)($a4a249b17eda019f$export$9fddb9d0dd7d8a54, 0, 2, "easeOutQuad", (v)=>{
                $a4a249b17eda019f$export$e923c3a79e3a8606(v);
            });
            setTimeout(()=>{
                $dab026e6ef7c0749$exports.play("labyrinthe-des-echos", {
                    gain: 0
                });
            }, 2000);
            setTimeout(()=>{
                $59d2451d2093640d$export$787f5d117f138d13(`
                    Cet \xe9pisode exp\xe9rience a \xe9t\xe9 cr\xe9\xe9e dans les locaux d\u{2019}INIZIO,<br>
                    \xe0 Vevey (CH) du 11 au 15 mars 2024 avec la participation de :<br>
                    <br>
                    Brendan, Charline, Dragos, Daniel, Daniel,<br>
                    Eline, Justin, Jonas, Laura, Leo,<br>
                    Lo\xefc, Mateo, Mauro, Nicolas, Purdey,<br>
                    Stefanie, et Willow<br>
                    <br>
                    <a href="https://low-project.ch/">low-project.ch</a><br>
                    <a href="https://inizio-vd.ch/">inizio-vd.ch</a>
                `.trim(), "Fin");
            }, 10000);
        }
    },
    {
        name: "stonehenge-triangle-1",
        position: {
            x: 0,
            y: -2,
            z: 1.8
        },
        color: "hsl(0, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 180,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_maraisOut", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-2",
        position: {
            x: 1.41,
            y: -1.41,
            z: 1.8
        },
        color: "hsl(45, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 225,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_machine", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-3",
        position: {
            x: 2,
            y: 0,
            z: 1.8
        },
        color: "hsl(90, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 270,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_Moskito", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-4",
        position: {
            x: 1.41,
            y: 1.41,
            z: 1.8
        },
        color: "hsl(135, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 315,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_Hey", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-5",
        position: {
            x: 0,
            y: 2,
            z: 1.8
        },
        color: "hsl(180, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 0,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_Inspir", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-6",
        position: {
            x: -1.41,
            y: 1.41,
            z: 1.8
        },
        color: "hsl(225, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 45,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_chuchot", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-7",
        position: {
            x: -2,
            y: 0,
            z: 1.8
        },
        color: "hsl(270, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 90,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_Melopee", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-8",
        position: {
            x: -1.41,
            y: -1.41,
            z: 1.8
        },
        color: "hsl(315, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 135,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $dab026e6ef7c0749$exports.play("Flash_grudge", {
                gain: 0
            });
        }
    }
];
var $09ab0b2b01afe74f$exports = {};
$09ab0b2b01afe74f$exports = new URL("../DingCle.8fd7974a.wav", import.meta.url).toString();


var $f41b9da6cfed5b9c$exports = {};
$f41b9da6cfed5b9c$exports = new URL("../DingCle2.b55dac96.wav", import.meta.url).toString();


var $9d207d25f1ef304a$exports = {};
$9d207d25f1ef304a$exports = new URL("../Flash_chuchot.11008de8.wav", import.meta.url).toString();


var $e7421528bedde7c2$exports = {};
$e7421528bedde7c2$exports = new URL("../Flash_grudge.cfb47c06.wav", import.meta.url).toString();


var $6d93756ce6d02084$exports = {};
$6d93756ce6d02084$exports = new URL("../Flash_Hey.0ec3308f.wav", import.meta.url).toString();


var $ed68b1c27b591775$exports = {};
$ed68b1c27b591775$exports = new URL("../Flash_Inspir.407d2023.wav", import.meta.url).toString();


var $c48adaf64e2d685a$exports = {};
$c48adaf64e2d685a$exports = new URL("../Flash_machine.321fef68.wav", import.meta.url).toString();


var $27888880a11774a7$exports = {};
$27888880a11774a7$exports = new URL("../Flash_MaraisOut.834e10a8.wav", import.meta.url).toString();


var $8aaf169b4c3c7a93$exports = {};
$8aaf169b4c3c7a93$exports = new URL("../Flash_Melopee.5a42748f.wav", import.meta.url).toString();


var $db8b1c0d24c0cf19$exports = {};
$db8b1c0d24c0cf19$exports = new URL("../Flash_Moskito.d4a96086.wav", import.meta.url).toString();


const $121c75b480798d23$var$sounds = [
    {
        name: "ding",
        url: new URL($09ab0b2b01afe74f$exports)
    },
    {
        name: "ding2",
        url: new URL($f41b9da6cfed5b9c$exports)
    },
    {
        name: "Flash_chuchot",
        url: new URL($9d207d25f1ef304a$exports)
    },
    {
        name: "Flash_grudge",
        url: new URL($e7421528bedde7c2$exports)
    },
    {
        name: "Flash_Hey",
        url: new URL($6d93756ce6d02084$exports)
    },
    {
        name: "Flash_Inspir",
        url: new URL($ed68b1c27b591775$exports)
    },
    {
        name: "Flash_machine",
        url: new URL($c48adaf64e2d685a$exports)
    },
    {
        name: "Flash_maraisOut",
        url: new URL($27888880a11774a7$exports)
    },
    {
        name: "Flash_Melopee",
        url: new URL($8aaf169b4c3c7a93$exports)
    },
    {
        name: "Flash_Moskito",
        url: new URL($db8b1c0d24c0cf19$exports)
    }
];
const $121c75b480798d23$var$images = [];
function $121c75b480798d23$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($121c75b480798d23$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($121c75b480798d23$var$sounds);
}







const $6ece93a81c4127ae$var$POIs = [
    {
        name: "demo-rouge",
        position: {
            x: -8,
            y: -8,
            z: 3
        },
        color: "red",
        radius: 5,
        sound: {
            name: "grains_pluie",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            // Follow player
            const originalPosition = {
                ...this.position
            };
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, $a4a249b17eda019f$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "demo-bleu",
        position: {
            x: 8,
            y: -8,
            z: 0.2
        },
        color: "blue",
        sound: {
            name: "hydro",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            this.sound.source.fadeTo(2, -90, 0);
        },
        onLeave () {
            this.sound.source.fadeTo(2, 0, -90);
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "demo-vert",
        position: {
            x: 8,
            y: 8,
            z: 0.5
        },
        color: "green",
        radius: 15,
        sound: {
            name: "metal-guitar",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "demo-jaune",
        position: {
            x: -8,
            y: 8,
            z: 1.8
        },
        color: "yellow",
        sound: {
            name: "histoire",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $828628221d283945$exports = {};
$828628221d283945$exports = new URL("../grains_pluie.4b748a48.wav", import.meta.url).toString();


var $793da72ec7154479$exports = {};
$793da72ec7154479$exports = new URL("../hydro.ba223b40.wav", import.meta.url).toString();


var $2ebe44543fb02869$exports = {};
$2ebe44543fb02869$exports = new URL("../histoire.f1f2b6d5.wav", import.meta.url).toString();


var $2a6fd16510e9ae01$exports = {};
$2a6fd16510e9ae01$exports = new URL("../metal-guitar.2c0b3812.wav", import.meta.url).toString();


const $6ece93a81c4127ae$var$sounds = [
    {
        name: "grains_pluie",
        url: new URL($828628221d283945$exports)
    },
    {
        name: "hydro",
        url: new URL($793da72ec7154479$exports)
    },
    {
        name: "histoire",
        url: new URL($2ebe44543fb02869$exports)
    },
    {
        name: "metal-guitar",
        url: new URL($2a6fd16510e9ae01$exports)
    }
];
const $6ece93a81c4127ae$var$images = [];
function $6ece93a81c4127ae$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($6ece93a81c4127ae$var$POIs);
    $14a6d3d86d620d4f$export$8250d5b41185d62d($6ece93a81c4127ae$var$images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($6ece93a81c4127ae$var$sounds);
}











let $c377ec5d5135246a$export$39f92e86d1722f3a;
function $c377ec5d5135246a$export$2cd8252107eb640b() {
    const canvas = document.querySelector("canvas");
    $c377ec5d5135246a$export$39f92e86d1722f3a = canvas.getContext("2d");
    canvas.width = (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width * devicePixelRatio;
    canvas.height = (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).height * devicePixelRatio;
    $c377ec5d5135246a$export$39f92e86d1722f3a.scale(devicePixelRatio, devicePixelRatio);
    if (DEVMODE) console.log(`Canvas initialized with DPR: ${devicePixelRatio} Size: ${canvas.width}/${canvas.height}`);
}
function $c377ec5d5135246a$export$42ffd38884aecdac() {
    $c377ec5d5135246a$export$39f92e86d1722f3a.clearRect(0, 0, (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width, (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).height);
}






// Config
const $f54ee5273209d384$export$e506a1d27d1eaa20 = {
    compassRadius: 150,
    maxCompassRadius: 150,
    pixelsPerMeter: 25,
    pointSeparation: 1
};
let $f54ee5273209d384$var$trackPlayer = true;
const $f54ee5273209d384$var$rotateWhileZooming = false;
const $f54ee5273209d384$export$3d9982e937097c50 = {
    x: 0,
    y: 0
};
let $f54ee5273209d384$var$cameraDirection = 0;
let $f54ee5273209d384$var$mode = "heading-up"; // 'north-up' or 'heading-up'
let $f54ee5273209d384$var$pointsInterval, $f54ee5273209d384$var$offscreenCanvas;
let $f54ee5273209d384$var$playerColor = "white";
function $f54ee5273209d384$export$2cd8252107eb640b() {
    $f54ee5273209d384$var$pointsInterval = $f54ee5273209d384$export$e506a1d27d1eaa20.pointSeparation * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter;
    $f54ee5273209d384$var$offscreenCanvas = new OffscreenCanvas((2 * $f54ee5273209d384$export$e506a1d27d1eaa20.maxCompassRadius + $f54ee5273209d384$var$pointsInterval * 2) * devicePixelRatio, (2 * $f54ee5273209d384$export$e506a1d27d1eaa20.maxCompassRadius + $f54ee5273209d384$var$pointsInterval * 2) * devicePixelRatio);
    $f54ee5273209d384$var$preparePointFieldImage();
// Example for changing playerColor every 500ms
// setInterval(() => {
//     playerColor = `hsl(${Math.random()*360}, 100%, 50%)`;
// }, 500);
}
function $f54ee5273209d384$export$722fbec263ad908a() {
    if ($f54ee5273209d384$var$trackPlayer) {
        $f54ee5273209d384$export$3d9982e937097c50.x = $a4a249b17eda019f$export$5880b8b5730aff45.x;
        $f54ee5273209d384$export$3d9982e937097c50.y = $a4a249b17eda019f$export$5880b8b5730aff45.y;
        $f54ee5273209d384$var$cameraDirection = $a4a249b17eda019f$export$9fddb9d0dd7d8a54;
    }
}
function $f54ee5273209d384$export$e529deb2bfd496dc() {
    // Example of a dynamic compass radius
    // config.compassRadius = 100 + Math.sin(Math.floor(Date.now() / 5 % 1000) / 1000 * Math.PI * 2) * 50;
    // Create clip path (same as compass outline)
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2, $f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius, 0, Math.PI * 2);
    // Clip further draws to compass outline
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).save();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).clip();
    $f54ee5273209d384$var$drawWorld();
    // Restore pre-clip
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).restore();
    $f54ee5273209d384$var$drawCompass();
}
function $f54ee5273209d384$var$drawWorld() {
    // Add translate and rotate to the transformation matrix for world coordinates
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).save();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).translate($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2);
    if ($f54ee5273209d384$var$mode === "heading-up") (0, $c377ec5d5135246a$export$39f92e86d1722f3a).rotate((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(-$f54ee5273209d384$var$cameraDirection));
    // Draw point field
    $f54ee5273209d384$var$drawPointField();
    // Draw world bounds
    $f54ee5273209d384$var$drawWorldBounds();
    // Draw entities
    $f54ee5273209d384$var$drawPOIs();
    $f54ee5273209d384$var$drawPlayer();
    // Restore transformation matrix to canvas coordinates
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).restore();
}
function $f54ee5273209d384$var$drawCompass() {
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "white";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 1;
    // Draw compass directions
    $f54ee5273209d384$var$drawCompassDirection(0, "N");
    $f54ee5273209d384$var$drawCompassDirection(90, "E");
    $f54ee5273209d384$var$drawCompassDirection(180, "S");
    $f54ee5273209d384$var$drawCompassDirection(270, "O");
    // Draw compass outline
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2, $f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius, 0, Math.PI * 2);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
}
function $f54ee5273209d384$var$drawWorldBounds() {
    const cameraPos = $f54ee5273209d384$var$worldToCanvas($f54ee5273209d384$export$3d9982e937097c50);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "white";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 1;
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).moveTo($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.left * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.top * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.right * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.top * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.right * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.bottom * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo($033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.left * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.bottom * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).closePath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
}
function $f54ee5273209d384$var$drawPlayer() {
    const cameraPos = $f54ee5273209d384$var$worldToCanvas($f54ee5273209d384$export$3d9982e937097c50);
    const playerPos = $f54ee5273209d384$var$worldToCanvas($a4a249b17eda019f$export$5880b8b5730aff45);
    // Add translate and rotate to the transformation matrix for world coordinates
    // TODO: convert all other draws with initial transforms then local coordinates like this method
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).save();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).translate(playerPos.x - cameraPos.x, playerPos.y - cameraPos.y);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).rotate((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)($a4a249b17eda019f$export$9fddb9d0dd7d8a54));
    // Draw player
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc(0, 12, 8, (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45), (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) + (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45));
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo(0, -8);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).closePath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = $f54ee5273209d384$var$playerColor;
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
    // Restore transformation matrix to canvas coordinates
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).restore();
}
function $f54ee5273209d384$var$drawCompassDirection(dir, txt) {
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "white";
    // Add player direction
    const angle = $f54ee5273209d384$var$mode === "heading-up" ? dir - $f54ee5273209d384$var$cameraDirection : dir;
    // Draw direction triangle
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2, $f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius, (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(angle) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(8), (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(angle) + (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(8));
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle)) * ($f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius + 20), $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle)) * ($f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius + 20));
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo($9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(8)) * $f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(8)) * $f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius);
    // Only North is filled
    if (dir === 0) {
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "black";
    } else (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
    // Draw text
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).font = "10px Helvetica Neue";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillText(txt, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle)) * ($f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius + 7) - 3.5, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(angle)) * ($f54ee5273209d384$export$e506a1d27d1eaa20.compassRadius + 7) + 3.5);
}
function $f54ee5273209d384$var$preparePointFieldImage() {
    const offctx = $f54ee5273209d384$var$offscreenCanvas.getContext("2d");
    offctx.clearRect(0, 0, $f54ee5273209d384$var$offscreenCanvas.width, $f54ee5273209d384$var$offscreenCanvas.height);
    offctx.fillStyle = "#444";
    for(let x = 0; x <= $f54ee5273209d384$var$offscreenCanvas.width; x += $f54ee5273209d384$var$pointsInterval)for(let y = 0; y <= $f54ee5273209d384$var$offscreenCanvas.height; y += $f54ee5273209d384$var$pointsInterval){
        offctx.beginPath();
        offctx.arc(x, y, 2, 0, Math.PI * 2);
        offctx.fill();
    }
}
function $f54ee5273209d384$var$drawPointField() {
    const cameraPos = $f54ee5273209d384$var$worldToCanvas($f54ee5273209d384$export$3d9982e937097c50);
    const offsetX = cameraPos.x % $f54ee5273209d384$var$pointsInterval;
    const offsetY = cameraPos.y % $f54ee5273209d384$var$pointsInterval;
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).drawImage($f54ee5273209d384$var$offscreenCanvas, -$f54ee5273209d384$export$e506a1d27d1eaa20.maxCompassRadius - $f54ee5273209d384$var$pointsInterval - offsetX, -$f54ee5273209d384$export$e506a1d27d1eaa20.maxCompassRadius - $f54ee5273209d384$var$pointsInterval - offsetY);
}
function $f54ee5273209d384$var$drawPOIs() {
    // TODO: filter out POIs that are outside the compass radius
    const visiblePOIs = $033227655e61e1ba$export$8061040b42890c32.filter((p)=>!p.invisible);
    for (const p of visiblePOIs){
        const cameraPos = $f54ee5273209d384$var$worldToCanvas($f54ee5273209d384$export$3d9982e937097c50);
        const poiPos = $f54ee5273209d384$var$worldToCanvas(p.position);
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = p.color;
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
        if (p.image) {
            // Draw image
            const imageWidth = $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].width / $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].ppm * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter;
            const imageHeight = $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].height / $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].ppm * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter;
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).drawImage($14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image], poiPos.x - cameraPos.x - imageWidth / 2, poiPos.y - cameraPos.y - imageHeight / 2, // Convention: images are sized at 25 pixels per meter
            imageWidth, imageHeight);
        } else if (p.type === "triangle") {
            // Draw a triangle centered on p.position
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).save();
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).translate(poiPos.x - cameraPos.x, poiPos.y - cameraPos.y);
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).rotate((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(p.rotation));
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).moveTo(Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(150)) * p.radius, Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(150)) * p.radius);
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo(0, -p.radius);
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo(Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(30)) * p.radius, Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(30)) * p.radius);
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).closePath();
            (0, $c377ec5d5135246a$export$39f92e86d1722f3a).restore();
        } else if (p.type === "circle" || !p.type) // Draw circle (default type)
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc(poiPos.x - cameraPos.x, poiPos.y - cameraPos.y, p.radius || 5, 0, Math.PI * 2);
        // Handling for styled shapes
        if (!p.image) {
            if (!p.style) (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
            else if (p.style === "idle") {
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "#223";
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "#99b";
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 1;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
            } else if (p.style === "active") {
                const timebase = Math.abs(Math.sin(Math.floor(Date.now() / 3 % 1000) / 1000 * Math.PI * 2));
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = p.color.replace("50%", `${timebase * 40 + 50}%`);
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 2;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
            } else if (p.style === "complete") {
                const timebase = Math.floor(Date.now() % 2000) / 2000;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = `hsl(${timebase * 360}, 50%, 30%)`;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = `hsl(${timebase * 360}, 100%, 50%)`;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 2;
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
                (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
            }
        }
    }
}
function $f54ee5273209d384$export$1fc0f6205829e19c() {
    return $f54ee5273209d384$var$mode;
}
function $f54ee5273209d384$export$ba03f2a005091f3b() {
    $f54ee5273209d384$var$mode = $f54ee5273209d384$var$mode === "heading-up" ? "north-up" : "heading-up";
}
function $f54ee5273209d384$export$bdcc994deaedab19() {
    $f54ee5273209d384$var$trackPlayer = false;
    new (0, $555be16020503cc9$export$208a41d6b4e37b97)($f54ee5273209d384$export$3d9982e937097c50, {
        x: 0,
        y: 0
    }, 2, "easeInOutQuad");
    if ($f54ee5273209d384$var$rotateWhileZooming) new (0, $555be16020503cc9$export$208a41d6b4e37b97)($f54ee5273209d384$var$cameraDirection, 0, 2, "easeInOutQuad", (v)=>{
        $f54ee5273209d384$var$cameraDirection = v;
    });
}
function $f54ee5273209d384$export$a66bf038d7620ad7() {
    new (0, $555be16020503cc9$export$208a41d6b4e37b97)($f54ee5273209d384$export$3d9982e937097c50, $a4a249b17eda019f$export$5880b8b5730aff45, 2, "easeInOutQuad", null, (tween)=>{
        $f54ee5273209d384$var$trackPlayer = true;
        tween.dispose();
    });
    if ($f54ee5273209d384$var$rotateWhileZooming) new (0, $555be16020503cc9$export$208a41d6b4e37b97)(0, $a4a249b17eda019f$export$9fddb9d0dd7d8a54, 2, "easeInOutQuad", (v)=>{
        $f54ee5273209d384$var$cameraDirection = v;
    });
}
// Convert world coordinates to canvas coordinates
// TODO: If this function serves only as a pixel-per-meter conversion, it should probably be deleted
function $f54ee5273209d384$var$worldToCanvas(vector) {
    return {
        x: vector.x * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter,
        y: vector.y * $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter
    };
}



const $2cb597b4d1b272ca$var$queuedTriangles = [];
function $2cb597b4d1b272ca$export$2cd8252107eb640b() {}
function $2cb597b4d1b272ca$var$isCollected(name) {
    return $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === name).style === "active";
}
function $2cb597b4d1b272ca$export$663103110d94aac9(name, position, options) {
    /*
        Options:
        - color
        - gain (dB)
        - collisionRadius (m)
        - offset {x, y} (m)
        - delay (s)
        - despawn (s)
    */ const pos = {
        x: position.x + (options.offset?.x || 0),
        y: position.y + (options.offset?.y || 0),
        z: 0
    };
    // Prevent dropping a collectible if its center sibling is already activated
    if ($2cb597b4d1b272ca$var$isCollected(name)) return;
    // Prevent dropping a collectible triangle again if its waiting for a timeout
    if ($2cb597b4d1b272ca$var$queuedTriangles.includes(`${name}-collectible`)) return;
    // Prevent dropping a collectible if it already exists
    if ($033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === `${name}-collectible`)) return;
    const centerTriangle = $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === name);
    // Drop a triangle at the given position
    const triangle = {
        name: `${name}-collectible`,
        position: pos,
        color: options.color || centerTriangle.color || "hsl(0, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        hideOnMap: true,
        collision: {
            radius: options.collisionRadius || 1
        },
        onEnter () {
            // Remove the triangle from the scene with splice
            const index = $033227655e61e1ba$export$8061040b42890c32.indexOf(this);
            $033227655e61e1ba$export$8061040b42890c32.splice(index, 1);
            $dab026e6ef7c0749$exports.play("ding", {
                gain: options.gain || 0
            });
            // Prevent the player from moving
            $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = false;
            // Zoom to the origin
            $f54ee5273209d384$export$bdcc994deaedab19();
            setTimeout(()=>{
                $2cb597b4d1b272ca$export$2dabce2e5d7031d0(name, options.gain || 0);
            }, 3000);
        }
    };
    const panner = (0, $71fc55f3cf0c7f08$export$604289ae06b8fa82)();
    panner.positionPanner(pos.x, pos.z, pos.y); // TODO: just pass pos !
    // Drop triangle after a few seconds
    setTimeout(()=>{
        $dab026e6ef7c0749$exports.play("ding-pop", {
            destination: panner,
            gain: options.gain || 0
        });
        $033227655e61e1ba$export$8061040b42890c32.push(triangle);
        $2cb597b4d1b272ca$var$queuedTriangles.splice($2cb597b4d1b272ca$var$queuedTriangles.indexOf(triangle.name), 1);
    }, options.delay * 1000 || 0);
    if (options.despawn) setTimeout(()=>{
        const index = $033227655e61e1ba$export$8061040b42890c32.indexOf(triangle);
        if (index) $033227655e61e1ba$export$8061040b42890c32.splice(index, 1);
    }, options.despawn * 1000);
    $2cb597b4d1b272ca$var$queuedTriangles.push(triangle.name);
}
function $2cb597b4d1b272ca$export$364cd37066d27690() {
    // Check if all collectible triangles have been picked
    const activeStonehengeTriangles = $033227655e61e1ba$export$8061040b42890c32.filter((p)=>{
        return p.name.includes("stonehenge-triangle") && p.style === "active";
    });
    return activeStonehengeTriangles.length === 8;
}
function $2cb597b4d1b272ca$export$2dabce2e5d7031d0(name, gain = 0, zoomBack = true) {
    $dab026e6ef7c0749$exports.play("ding2", {
        gain: gain
    });
    const triangle = $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === name);
    triangle.style = "active";
    const complete = $2cb597b4d1b272ca$export$364cd37066d27690();
    setTimeout(()=>{
        if (!complete) {
            if (zoomBack) $2cb597b4d1b272ca$var$zoomBackToPlayer();
        } else $2cb597b4d1b272ca$var$animateStonehengeComplete();
    }, 2000);
}
function $2cb597b4d1b272ca$var$animateStonehengeComplete() {
    $dab026e6ef7c0749$exports.play("ding-final");
    const center = $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === "stonehenge-center");
    center.style = "complete";
    setTimeout(()=>{
        $2cb597b4d1b272ca$var$zoomBackToPlayer();
    }, 2000);
}
function $2cb597b4d1b272ca$var$zoomBackToPlayer() {
    $f54ee5273209d384$export$a66bf038d7620ad7();
    setTimeout(()=>{
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = true;
    }, 2000);
}


// NOTE: IDEA: Should there be a faint trace of the grudge drawn on the floor?
let $f641732553607f44$var$whistlePanner;
const $f641732553607f44$var$POIs = [
    {
        name: "grudge",
        position: {
            x: -26,
            y: 11,
            z: 0.5
        },
        color: "violet",
        hideOnMap: true,
        sound: {
            name: "grudge",
            gain: 0
        },
        wander: {
            mode: "loop",
            points: [
                {
                    x: -26,
                    y: 11,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -28,
                    y: -4,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -19,
                    y: -19,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -4,
                    y: -14,
                    z: 0.5,
                    s: 1
                },
                {
                    x: 7,
                    y: -20,
                    z: 0.5,
                    s: 1
                },
                {
                    x: 16,
                    y: 8,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -9,
                    y: 14,
                    z: 0.5,
                    s: 1
                }
            ],
            pause (callback) {
                // FIXME: There should be a better way to get this POI main sound source reference
                //        Maybe the pause method should be on POIs root ?
                const p = $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === "grudge");
                // Fade out the main POI sound
                p.sound.source.fade();
                // Position the whistle panner and play the sound once
                $f641732553607f44$var$whistlePanner.positionPanner(p.position.x, p.position.z, p.position.y);
                $dab026e6ef7c0749$exports.play("whistle", {
                    destination: $f641732553607f44$var$whistlePanner,
                    gain: 0
                });
                // Drop key
                $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-8", p.position, {
                    collisionRadius: 0.5,
                    despawn: 12,
                    offset: {
                        x: 0.8,
                        y: -0.8
                    }
                });
                setTimeout(()=>{
                    p.sound.source.fadeTo(2, 0, -90);
                    callback();
                }, 12000);
            }
        },
        async onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
            $f641732553607f44$var$whistlePanner = $71fc55f3cf0c7f08$exports.createPanner();
        }
    }
];
var $c2feaeb3721c1dea$exports = {};
$c2feaeb3721c1dea$exports = new URL("../GrudgeComplet.90e25522.wav", import.meta.url).toString();


var $7aefb0ed0fc00cf8$exports = {};
$7aefb0ed0fc00cf8$exports = new URL("../GrudgeSiffle.e58caf57.wav", import.meta.url).toString();


const $f641732553607f44$var$sounds = [
    {
        name: "grudge",
        url: new URL($c2feaeb3721c1dea$exports)
    },
    {
        name: "whistle",
        url: new URL($7aefb0ed0fc00cf8$exports)
    }
];
const $f641732553607f44$var$images = [];
function $f641732553607f44$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($f641732553607f44$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($f641732553607f44$var$sounds);
}







let $3598a1ed6e3fd493$var$hydroSound;
const $3598a1ed6e3fd493$var$POIs = [
    {
        name: "lake",
        position: {
            x: -10,
            y: -22,
            z: 0
        },
        image: "lake",
        sound: {
            name: "swamp",
            gain: 0
        },
        symbolic: false,
        collision: {
            radius: 4
        },
        async onEnter () {
            $dab026e6ef7c0749$exports.play("lakePlouf");
            $3598a1ed6e3fd493$var$hydroSound = await $dab026e6ef7c0749$exports.play("hydro", {
                loop: true,
                gain: 0,
                when: 0.6
            });
            $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 1;
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-1", this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: {
                    x: 1.5,
                    y: -2
                }
            });
        },
        onLeave () {
            $dab026e6ef7c0749$exports.play("lakeOut", {
                gain: 0
            });
            $3598a1ed6e3fd493$var$hydroSound.stop();
            $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 2.5;
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];

var $158a71dcfcb2c55f$exports = {};
$158a71dcfcb2c55f$exports = new URL("../MaraisPlouf.07309f16.wav", import.meta.url).toString();


var $bb2d9fb5f2bcb4cb$exports = {};
$bb2d9fb5f2bcb4cb$exports = new URL("../MaraisOut.834e10a8.wav", import.meta.url).toString();


const $3598a1ed6e3fd493$var$sounds = [
    {
        name: "hydro",
        url: new URL($793da72ec7154479$exports)
    },
    {
        name: "lakePlouf",
        url: new URL($158a71dcfcb2c55f$exports)
    },
    {
        name: "lakeOut",
        url: new URL($bb2d9fb5f2bcb4cb$exports)
    }
];
var $a432ef2a17032441$exports = {};
$a432ef2a17032441$exports = new URL("../lake.aea94cbb.png", import.meta.url).toString();


const $3598a1ed6e3fd493$var$images = [
    {
        name: "lake",
        url: new URL($a432ef2a17032441$exports),
        ppm: 25
    }
];
function $3598a1ed6e3fd493$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($3598a1ed6e3fd493$var$POIs);
    $14a6d3d86d620d4f$export$8250d5b41185d62d($3598a1ed6e3fd493$var$images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($3598a1ed6e3fd493$var$sounds);
}








let $1a9e232e06253b84$var$mosquito;
let $1a9e232e06253b84$var$moskitoPanner;
const $1a9e232e06253b84$var$POIs = [
    {
        name: "swamp",
        position: {
            x: 24,
            y: 4,
            z: 0
        },
        image: "swamp",
        symbolic: false,
        sound: {
            name: "swamp",
            gain: 0
        },
        collision: {
            radius: 2.4
        },
        async onEnter () {
            $1a9e232e06253b84$var$moskitoPanner.positionPanner(this.position.x, this.position.z, this.position.y); // TODO: just pass pos !
            $1a9e232e06253b84$var$mosquito = await $dab026e6ef7c0749$exports.play("mosquito", {
                loop: true,
                gain: 0,
                destination: $1a9e232e06253b84$var$moskitoPanner
            });
            // TODO: make the mosquito spin around
            $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 1.4;
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-3", this.position, {
                collisionRadius: 0.5,
                delay: 5
            });
        },
        onLeave () {
            $1a9e232e06253b84$var$mosquito.fade(2, -90, true);
            $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 2.5;
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $4dcf7bd87eb1db82$exports = {};
$4dcf7bd87eb1db82$exports = new URL("../Moskito.2c9991b5.wav", import.meta.url).toString();


var $4ddd6842878a81f8$exports = {};
$4ddd6842878a81f8$exports = new URL("../Marais.9e279127.wav", import.meta.url).toString();


const $1a9e232e06253b84$var$sounds = [
    {
        name: "mosquito",
        url: new URL($4dcf7bd87eb1db82$exports)
    },
    {
        name: "swamp",
        url: new URL($4ddd6842878a81f8$exports)
    }
];
var $031afecc8c2a485b$exports = {};
$031afecc8c2a485b$exports = new URL("../swamp.433342ed.png", import.meta.url).toString();


const $1a9e232e06253b84$var$images = [
    {
        name: "swamp",
        url: new URL($031afecc8c2a485b$exports),
        ppm: 25
    }
];
function $1a9e232e06253b84$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($1a9e232e06253b84$var$POIs);
    $14a6d3d86d620d4f$export$8250d5b41185d62d($1a9e232e06253b84$var$images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($1a9e232e06253b84$var$sounds);
    $1a9e232e06253b84$var$moskitoPanner = (0, $71fc55f3cf0c7f08$export$604289ae06b8fa82)();
}






const $0734ad466e8ae61c$var$POIs = [
    {
        name: "chat",
        position: {
            x: 20,
            y: -14,
            z: 0
        },
        color: "white",
        sound: {
            name: "chat",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $630b8a57908e8e9d$exports = {};
$630b8a57908e8e9d$exports = new URL("../Chat.1696e156.wav", import.meta.url).toString();


const $0734ad466e8ae61c$var$sounds = [
    {
        name: "chat",
        url: new URL($630b8a57908e8e9d$exports)
    }
];
const $0734ad466e8ae61c$var$images = [];
function $0734ad466e8ae61c$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($0734ad466e8ae61c$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($0734ad466e8ae61c$var$sounds);
}






const $e1ab84328d645f33$var$POIs = [
    {
        name: "chewing-gum",
        position: {
            x: -19,
            y: -13,
            z: 0
        },
        color: "white",
        sound: {
            name: "chewing-gum",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $4291c77d74b36dee$exports = {};
$4291c77d74b36dee$exports = new URL("../ChewingGum.ae6dd0e2.wav", import.meta.url).toString();


const $e1ab84328d645f33$var$sounds = [
    {
        name: "chewing-gum",
        url: new URL($4291c77d74b36dee$exports)
    }
];
const $e1ab84328d645f33$var$images = [];
function $e1ab84328d645f33$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($e1ab84328d645f33$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($e1ab84328d645f33$var$sounds);
}







let $e1e9378d7ea6c77f$var$pedaloSound;
const $e1e9378d7ea6c77f$var$POIs = [
    {
        name: "pedalo",
        position: {
            x: 8,
            y: -27,
            z: 0
        },
        color: "blue",
        radius: 5,
        sound: {
            name: "pedalo-idle",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            $e1e9378d7ea6c77f$var$pedaloSound = await $dab026e6ef7c0749$exports.play("pedalo", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, $a4a249b17eda019f$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $e1e9378d7ea6c77f$var$pedaloSound.fade();
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $d522449996b34451$exports = {};
$d522449996b34451$exports = new URL("../Pedalo_pause.223fcbb8.wav", import.meta.url).toString();


var $343f78bb30e02287$exports = {};
$343f78bb30e02287$exports = new URL("../Pedalo.e7f2b40c.wav", import.meta.url).toString();


const $e1e9378d7ea6c77f$var$sounds = [
    {
        name: "pedalo-idle",
        url: new URL($d522449996b34451$exports)
    },
    {
        name: "pedalo",
        url: new URL($343f78bb30e02287$exports)
    }
];
const $e1e9378d7ea6c77f$var$images = [];
function $e1e9378d7ea6c77f$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($e1e9378d7ea6c77f$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($e1e9378d7ea6c77f$var$sounds);
}







let $2a6233dca10681ed$var$moteurSound;
const $2a6233dca10681ed$var$POIs = [
    {
        name: "moteur",
        position: {
            x: 38,
            y: -8,
            z: 0
        },
        color: "red",
        radius: 5,
        sound: {
            name: "moteur-idle",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            $2a6233dca10681ed$var$moteurSound = await $dab026e6ef7c0749$exports.play("moteur", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, $a4a249b17eda019f$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $2a6233dca10681ed$var$moteurSound.fade();
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $0766f9de1f1635e4$exports = {};
$0766f9de1f1635e4$exports = new URL("../Moteur_pause.9b741378.wav", import.meta.url).toString();


var $f7171ec072474a3b$exports = {};
$f7171ec072474a3b$exports = new URL("../Moteur.f8878ae3.wav", import.meta.url).toString();


const $2a6233dca10681ed$var$sounds = [
    {
        name: "moteur-idle",
        url: new URL($0766f9de1f1635e4$exports)
    },
    {
        name: "moteur",
        url: new URL($f7171ec072474a3b$exports)
    }
];
const $2a6233dca10681ed$var$images = [];
function $2a6233dca10681ed$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($2a6233dca10681ed$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($2a6233dca10681ed$var$sounds);
}






let $6dd0ea4250431527$var$melopee;
const $6dd0ea4250431527$var$pluieGain = 12;
const $6dd0ea4250431527$var$POIs = [
    {
        name: "pluie",
        position: {
            x: -23,
            y: 8,
            z: 0
        },
        color: "hsl(225, 100%, 50%)",
        sound: {
            name: "pluie",
            gain: $6dd0ea4250431527$var$pluieGain
        },
        collision: {
            radius: 2
        },
        async onEnter () {
            this.sound.source.fadeTo(2, -90, $6dd0ea4250431527$var$pluieGain);
            this.collision.radius = 4;
            $6dd0ea4250431527$var$melopee = await $dab026e6ef7c0749$exports.play("melopee", {
                destination: this.sound.panner,
                gain: 0,
                when: 2
            });
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-7", this.position, {
                collisionRadius: 0.5,
                delay: 8
            });
        },
        onLeave () {
            this.sound.source.fadeTo(2, $6dd0ea4250431527$var$pluieGain, -90);
            this.collision.radius = 2;
            $6dd0ea4250431527$var$melopee?.fade(2, -90, true);
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $1bc5394f7f7129a0$exports = {};
$1bc5394f7f7129a0$exports = new URL("../PluieLegere_canopee.1425763c.wav", import.meta.url).toString();


var $a81aca2f198dbc6d$exports = {};
$a81aca2f198dbc6d$exports = new URL("../Melopee_sirene.ca25a133.wav", import.meta.url).toString();


const $6dd0ea4250431527$var$sounds = [
    {
        name: "pluie",
        url: new URL($1bc5394f7f7129a0$exports)
    },
    {
        name: "melopee",
        url: new URL($a81aca2f198dbc6d$exports)
    }
];
const $6dd0ea4250431527$var$images = [];
function $6dd0ea4250431527$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($6dd0ea4250431527$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($6dd0ea4250431527$var$sounds);
}







let $84bc8903e78bfd3c$var$veloSound;
const $84bc8903e78bfd3c$var$POIs = [
    {
        name: "velo",
        position: {
            x: -18,
            y: 20,
            z: 0
        },
        color: "orange",
        radius: 5,
        sound: {
            name: "velo-idle",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            $84bc8903e78bfd3c$var$veloSound = await $dab026e6ef7c0749$exports.play("velo", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, $a4a249b17eda019f$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $84bc8903e78bfd3c$var$veloSound.fade();
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $2b9a157361f491da$exports = {};
$2b9a157361f491da$exports = new URL("../SonetteCourte.f8b587f8.wav", import.meta.url).toString();


var $1b48e5e79dfb74d8$exports = {};
$1b48e5e79dfb74d8$exports = new URL("../ChaineVelo.9f0a6bab.wav", import.meta.url).toString();


const $84bc8903e78bfd3c$var$sounds = [
    {
        name: "velo-idle",
        url: new URL($2b9a157361f491da$exports)
    },
    {
        name: "velo",
        url: new URL($1b48e5e79dfb74d8$exports)
    }
];
const $84bc8903e78bfd3c$var$images = [];
function $84bc8903e78bfd3c$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($84bc8903e78bfd3c$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($84bc8903e78bfd3c$var$sounds);
}






const $7040a69cf9948f08$var$POIs = [
    {
        name: "dialogue-l",
        position: {
            x: -31,
            y: -7,
            z: 0
        },
        color: "white",
        sound: {
            name: "dialogue-l",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "dialogue-r",
        position: {
            x: -29,
            y: -8,
            z: 0
        },
        color: "white",
        sound: {
            name: "dialogue-r",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $34bf33c871f0a7fb$exports = {};
$34bf33c871f0a7fb$exports = new URL("../DialogueBizarreL.30378a28.wav", import.meta.url).toString();


var $aeebfa6a8e330d84$exports = {};
$aeebfa6a8e330d84$exports = new URL("../DialogueBizarreR.d09acdcf.wav", import.meta.url).toString();


const $7040a69cf9948f08$var$sounds = [
    {
        name: "dialogue-l",
        url: new URL($34bf33c871f0a7fb$exports)
    },
    {
        name: "dialogue-r",
        url: new URL($aeebfa6a8e330d84$exports)
    }
];
const $7040a69cf9948f08$var$images = [];
function $7040a69cf9948f08$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($7040a69cf9948f08$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($7040a69cf9948f08$var$sounds);
}






const $7bdc81708f731a2d$var$POIs = [
    {
        name: "machine-1",
        position: {
            x: 31,
            y: -26,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-1",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "machine-2",
        position: {
            x: 34,
            y: -27,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-2",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "machine-3",
        position: {
            x: 35,
            y: -24,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-3",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "machine-4",
        position: {
            x: 32,
            y: -23,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-4",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "espace",
        position: {
            x: 33,
            y: -25,
            z: 0
        },
        color: "white",
        invisible: true,
        collision: {
            radius: 3
        },
        onEnter () {
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-2", this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: {
                    x: 3,
                    y: -2
                }
            });
        },
        onLeave () {
            $dab026e6ef7c0749$exports.play("espace", {
                gain: 0
            });
        }
    }
];
var $f4b11cfbb588831c$exports = {};
$f4b11cfbb588831c$exports = new URL("../Usine1.42b6a4a7.wav", import.meta.url).toString();


var $bb947eeb0e836f0f$exports = {};
$bb947eeb0e836f0f$exports = new URL("../Usine2.379f6384.wav", import.meta.url).toString();


var $8d991dd27ce15edd$exports = {};
$8d991dd27ce15edd$exports = new URL("../Usine3.f19dcc23.wav", import.meta.url).toString();


var $da7f8826c80a196a$exports = {};
$da7f8826c80a196a$exports = new URL("../Usine4.96ea14c8.wav", import.meta.url).toString();


var $e8c1cb7fd57689d4$exports = {};
$e8c1cb7fd57689d4$exports = new URL("../Espace.273b06d3.wav", import.meta.url).toString();


const $7bdc81708f731a2d$var$sounds = [
    {
        name: "machine-1",
        url: new URL($f4b11cfbb588831c$exports)
    },
    {
        name: "machine-2",
        url: new URL($bb947eeb0e836f0f$exports)
    },
    {
        name: "machine-3",
        url: new URL($8d991dd27ce15edd$exports)
    },
    {
        name: "machine-4",
        url: new URL($da7f8826c80a196a$exports)
    },
    {
        name: "espace",
        url: new URL($e8c1cb7fd57689d4$exports)
    }
];
const $7bdc81708f731a2d$var$images = [];
function $7bdc81708f731a2d$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($7bdc81708f731a2d$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($7bdc81708f731a2d$var$sounds);
}






const $049bbb6720600fed$var$POIs = [
    {
        name: "couplet-1",
        position: {
            x: -33,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-1",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "couplet-2",
        position: {
            x: -35,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-2",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "couplet-3",
        position: {
            x: -35,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-3",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "couplet-4",
        position: {
            x: -33,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-4",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "couplet-5",
        position: {
            x: -34,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-5",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-6", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: -3,
                    y: 3
                },
                delay: 5,
                gain: 0
            });
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $2cb8acf70b4850c9$exports = {};
$2cb8acf70b4850c9$exports = new URL("../Couplet1.b500094b.wav", import.meta.url).toString();


var $b5ff4f7049c96a81$exports = {};
$b5ff4f7049c96a81$exports = new URL("../Couplet2.68f03748.wav", import.meta.url).toString();


var $8b7f5eaf5e75ed55$exports = {};
$8b7f5eaf5e75ed55$exports = new URL("../Couplet3.2a6113c9.wav", import.meta.url).toString();


var $15fab2d6bd5badbf$exports = {};
$15fab2d6bd5badbf$exports = new URL("../Couplet4.6ea6e560.wav", import.meta.url).toString();


var $12214ad03cb07c5d$exports = {};
$12214ad03cb07c5d$exports = new URL("../Couplet5.3079d01f.wav", import.meta.url).toString();


const $049bbb6720600fed$var$sounds = [
    {
        name: "couplet-1",
        url: new URL($2cb8acf70b4850c9$exports)
    },
    {
        name: "couplet-2",
        url: new URL($b5ff4f7049c96a81$exports)
    },
    {
        name: "couplet-3",
        url: new URL($8b7f5eaf5e75ed55$exports)
    },
    {
        name: "couplet-4",
        url: new URL($15fab2d6bd5badbf$exports)
    },
    {
        name: "couplet-5",
        url: new URL($12214ad03cb07c5d$exports)
    }
];
const $049bbb6720600fed$var$images = [];
function $049bbb6720600fed$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($049bbb6720600fed$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($049bbb6720600fed$var$sounds);
}






const $00dc951c29b709f9$var$POIs = [
    {
        name: "hey-1",
        position: {
            x: 34,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-1",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "hey-2",
        position: {
            x: 35,
            y: 25,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-2",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "hey-3",
        position: {
            x: 36,
            y: 26,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-3",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "hey-4",
        position: {
            x: 37,
            y: 27,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-4",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-4", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: 1,
                    y: 1
                },
                delay: 1
            });
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $1ca6a2c5c5ea8186$exports = {};
$1ca6a2c5c5ea8186$exports = new URL("../Hey1.99eb2b1c.wav", import.meta.url).toString();


var $68bf8117a8935503$exports = {};
$68bf8117a8935503$exports = new URL("../Hey2.6f8ad809.wav", import.meta.url).toString();


var $d736576b9243613f$exports = {};
$d736576b9243613f$exports = new URL("../Hey3.191e5841.wav", import.meta.url).toString();


var $577156742c0aafed$exports = {};
$577156742c0aafed$exports = new URL("../Hey4.ec71dfcc.wav", import.meta.url).toString();


const $00dc951c29b709f9$var$sounds = [
    {
        name: "hey-1",
        url: new URL($1ca6a2c5c5ea8186$exports)
    },
    {
        name: "hey-2",
        url: new URL($68bf8117a8935503$exports)
    },
    {
        name: "hey-3",
        url: new URL($d736576b9243613f$exports)
    },
    {
        name: "hey-4",
        url: new URL($577156742c0aafed$exports)
    }
];
const $00dc951c29b709f9$var$images = [];
function $00dc951c29b709f9$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($00dc951c29b709f9$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($00dc951c29b709f9$var$sounds);
}







const $e36c5e0c3a05d301$var$POIs = [
    {
        name: "inspire-1",
        position: {
            x: 2,
            y: 21,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-1",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "inspire-2",
        position: {
            x: 2,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-2",
            gain: 0,
            delay: 1.3
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "inspire-3",
        position: {
            x: 2,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-3",
            gain: 0,
            delay: 0.9
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "inspire-4",
        position: {
            x: 2,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-4",
            gain: 0,
            delay: 2.4
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "expire-1",
        position: {
            x: 4,
            y: 21,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-1",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "expire-2",
        position: {
            x: 4,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-2",
            gain: 0,
            delay: 2.1
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "expire-3",
        position: {
            x: 4,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-3",
            gain: 0,
            delay: 1.6
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "expire-4",
        position: {
            x: 4,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-4",
            gain: 0,
            delay: 0.9
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    },
    {
        name: "respire",
        position: {
            x: 3,
            y: 22.5,
            z: 0
        },
        color: "white",
        invisible: true,
        collision: {
            radius: 3
        },
        onEnter () {
            $2cb597b4d1b272ca$export$663103110d94aac9("stonehenge-triangle-5", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: 3,
                    y: 0
                },
                delay: 7,
                gain: 0
            });
        }
    }
];
var $1eb9a84cc5fd82db$exports = {};
$1eb9a84cc5fd82db$exports = new URL("../Inspir1.285e5108.wav", import.meta.url).toString();


var $c6ffa1042fc2fe50$exports = {};
$c6ffa1042fc2fe50$exports = new URL("../Inspir2.efd9e7aa.wav", import.meta.url).toString();


var $b33f675c1aa7cfcc$exports = {};
$b33f675c1aa7cfcc$exports = new URL("../Inspir3.3c6e37bd.wav", import.meta.url).toString();


var $2af730611730166d$exports = {};
$2af730611730166d$exports = new URL("../Inspir4.6318af05.wav", import.meta.url).toString();


var $e3e5d7be66cca244$exports = {};
$e3e5d7be66cca244$exports = new URL("../Expir1.22119bdd.wav", import.meta.url).toString();


var $b1d990d9a4af3edb$exports = {};
$b1d990d9a4af3edb$exports = new URL("../Expir2.f11f0986.wav", import.meta.url).toString();


var $23fa67b6e5a33c06$exports = {};
$23fa67b6e5a33c06$exports = new URL("../Expir3.adfc6ee5.wav", import.meta.url).toString();


var $c6079c72c37064d9$exports = {};
$c6079c72c37064d9$exports = new URL("../Expir4.f51f1076.wav", import.meta.url).toString();


const $e36c5e0c3a05d301$var$sounds = [
    {
        name: "inspire-1",
        url: new URL($1eb9a84cc5fd82db$exports)
    },
    {
        name: "inspire-2",
        url: new URL($c6ffa1042fc2fe50$exports)
    },
    {
        name: "inspire-3",
        url: new URL($b33f675c1aa7cfcc$exports)
    },
    {
        name: "inspire-4",
        url: new URL($2af730611730166d$exports)
    },
    {
        name: "expire-1",
        url: new URL($e3e5d7be66cca244$exports)
    },
    {
        name: "expire-2",
        url: new URL($b1d990d9a4af3edb$exports)
    },
    {
        name: "expire-3",
        url: new URL($23fa67b6e5a33c06$exports)
    },
    {
        name: "expire-4",
        url: new URL($c6079c72c37064d9$exports)
    }
];
const $e36c5e0c3a05d301$var$images = [];
function $e36c5e0c3a05d301$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($e36c5e0c3a05d301$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($e36c5e0c3a05d301$var$sounds);
}







let $f3011360a2fa8e04$var$chameauSound;
const $f3011360a2fa8e04$var$POIs = [
    {
        name: "chameau",
        position: {
            x: 22,
            y: 18,
            z: 0
        },
        color: "#7f5d49",
        radius: 5,
        sound: {
            name: "chameau-idle",
            gain: 0
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            $f3011360a2fa8e04$var$chameauSound = await $dab026e6ef7c0749$exports.play("chameau", {
                loop: true,
                gain: 0
            });
            $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 1.5;
            const originalPosition = {
                ...this.position
            };
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, $a4a249b17eda019f$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $f3011360a2fa8e04$var$chameauSound.fade();
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                    $a4a249b17eda019f$export$e506a1d27d1eaa20.maxVelocity = 2.5;
                }, 10000);
            });
            // Increase radius to 15
            new (0, $555be16020503cc9$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $284bfeb8bc988b32$exports = {};
$284bfeb8bc988b32$exports = new URL("../Chameau_Pause.289721ad.wav", import.meta.url).toString();


var $58e5d5e083472cd2$exports = {};
$58e5d5e083472cd2$exports = new URL("../Chameau.b7416d89.wav", import.meta.url).toString();


const $f3011360a2fa8e04$var$sounds = [
    {
        name: "chameau-idle",
        url: new URL($284bfeb8bc988b32$exports)
    },
    {
        name: "chameau",
        url: new URL($58e5d5e083472cd2$exports)
    }
];
const $f3011360a2fa8e04$var$images = [];
function $f3011360a2fa8e04$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($f3011360a2fa8e04$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($f3011360a2fa8e04$var$sounds);
}







let $33e87092881aa4b4$var$voix;
const $33e87092881aa4b4$var$POIs = [
    {
        name: "telephone",
        position: {
            x: -7,
            y: 10,
            z: 0
        },
        color: "white",
        sound: {
            name: "telephone",
            gain: 0
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            this.sound.source.fadeTo(0, -90, 0);
            $33e87092881aa4b4$var$voix = await $dab026e6ef7c0749$exports.play("voix", {
                destination: this.sound.panner,
                gain: 0
            });
        },
        onLeave () {
            this.sound.source.fadeTo(1, 0, -90);
            $33e87092881aa4b4$var$voix?.fade(1, -90, true);
        },
        onStart () {
            $71fc55f3cf0c7f08$exports.play(this);
        }
    }
];
var $c5f13eaf91918573$exports = {};
$c5f13eaf91918573$exports = new URL("../telephone.11a028ce.wav", import.meta.url).toString();


var $2ee694556c9b72b0$exports = {};
$2ee694556c9b72b0$exports = new URL("../VoixTelephone.393e5d4f.wav", import.meta.url).toString();


const $33e87092881aa4b4$var$sounds = [
    {
        name: "telephone",
        url: new URL($c5f13eaf91918573$exports)
    },
    {
        name: "voix",
        url: new URL($2ee694556c9b72b0$exports)
    }
];
const $33e87092881aa4b4$var$images = [];
function $33e87092881aa4b4$export$2cd8252107eb640b() {
    $033227655e61e1ba$export$1d3a1dba469744a6($33e87092881aa4b4$var$POIs);
    //loader.addImages(images);
    $14a6d3d86d620d4f$export$cb43b96ee3d96841($33e87092881aa4b4$var$sounds);
}


let $033227655e61e1ba$var$started = false;
// TODO: this module.config.whatever is too verbose, think about a better way to handle this
const $033227655e61e1ba$export$e506a1d27d1eaa20 = {
    // All sizes in meters
    worldSize: {
        width: 80,
        height: 60
    },
    worldOrigin: {
        x: 40,
        y: 30
    },
    playerStart: {
        x: 0,
        y: 0
    }
};
const $033227655e61e1ba$export$8061040b42890c32 = [];
let $033227655e61e1ba$var$contactingBoundsSound;
var $b0fa305397d4ed8b$exports = {};
$b0fa305397d4ed8b$exports = new URL("../BarriereElectrique.183e8f59.wav", import.meta.url).toString();


var $fcd644672ca21f8a$exports = {};
$fcd644672ca21f8a$exports = new URL("../DingClewav.559f7c4f.wav", import.meta.url).toString();


var $a051af4c94562297$exports = {};
$a051af4c94562297$exports = new URL("../DingFinal.ebde80d2.wav", import.meta.url).toString();


var $02daac2c2aa58f4d$exports = {};
$02daac2c2aa58f4d$exports = new URL("../LabyrinthEcho.40a5104a.mp3", import.meta.url).toString();


function $033227655e61e1ba$export$2cd8252107eb640b() {
    // Calculate world bounds
    $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds = {};
    $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.top = $033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.y - $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.height;
    $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.right = $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.width - $033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.x;
    $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.bottom = $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.height - $033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.y;
    $033227655e61e1ba$export$e506a1d27d1eaa20.worldBounds.left = $033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.x - $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.width;
    $121c75b480798d23$export$2cd8252107eb640b();
    //demo.init();
    $f641732553607f44$export$2cd8252107eb640b();
    $3598a1ed6e3fd493$export$2cd8252107eb640b();
    $1a9e232e06253b84$export$2cd8252107eb640b();
    $0734ad466e8ae61c$export$2cd8252107eb640b();
    $e1ab84328d645f33$export$2cd8252107eb640b();
    $e1e9378d7ea6c77f$export$2cd8252107eb640b();
    $2a6233dca10681ed$export$2cd8252107eb640b();
    $6dd0ea4250431527$export$2cd8252107eb640b();
    $84bc8903e78bfd3c$export$2cd8252107eb640b();
    $7040a69cf9948f08$export$2cd8252107eb640b();
    $7bdc81708f731a2d$export$2cd8252107eb640b();
    $049bbb6720600fed$export$2cd8252107eb640b();
    $00dc951c29b709f9$export$2cd8252107eb640b();
    $e36c5e0c3a05d301$export$2cd8252107eb640b();
    $f3011360a2fa8e04$export$2cd8252107eb640b();
    $33e87092881aa4b4$export$2cd8252107eb640b();
    $14a6d3d86d620d4f$export$cb43b96ee3d96841([
        {
            name: "barriere",
            url: new URL($b0fa305397d4ed8b$exports)
        },
        {
            name: "ding-pop",
            url: new URL($fcd644672ca21f8a$exports)
        },
        {
            name: "ding-final",
            url: new URL($a051af4c94562297$exports)
        },
        {
            name: "labyrinthe-des-echos",
            url: new URL($02daac2c2aa58f4d$exports)
        }
    ]);
    return $14a6d3d86d620d4f$export$2cd8252107eb640b();
}
function $033227655e61e1ba$export$b3571188c770cc5a() {
    if (!$033227655e61e1ba$var$started) {
        $033227655e61e1ba$var$started = true;
        $033227655e61e1ba$var$playSounds();
        $033227655e61e1ba$var$startPOIs();
        (0, $f07678ac589b406d$export$3274927b96bdf2f0)();
        $033227655e61e1ba$var$startWanderers();
    }
}
function $033227655e61e1ba$export$1d3a1dba469744a6(newPOIs) {
    $033227655e61e1ba$export$8061040b42890c32.push(...newPOIs);
}
function $033227655e61e1ba$var$playSounds() {
    $dab026e6ef7c0749$exports.play("barriere", {
        gain: -90,
        loop: true
    }).then((source)=>{
        $033227655e61e1ba$var$contactingBoundsSound = source;
    });
// FIXME: Temporary psychoacoustic test
// TODO: Implement spatial reverb
// audio.buffers.play('bruit-de-fond', {
//     gain: 0, // in dB
//     loop: true,
// });
}
function $033227655e61e1ba$var$startPOIs() {
    const POIsWithOnStart = $033227655e61e1ba$export$8061040b42890c32.filter((p)=>p.onStart);
    POIsWithOnStart.forEach((p)=>{
        if (typeof p.onStart === "function") p.onStart();
    });
}
function $033227655e61e1ba$export$722fbec263ad908a() {
    $033227655e61e1ba$export$8061040b42890c32.forEach((p)=>{
        // Handle player collision
        if (p.collision) {
            const distance = Math.sqrt(Math.pow(p.position.x - $a4a249b17eda019f$export$5880b8b5730aff45.x, 2) + Math.pow(p.position.y - $a4a249b17eda019f$export$5880b8b5730aff45.y, 2));
            if (distance < p.collision.radius) {
                if (p.collision.active !== true) {
                    p.collision.active = true;
                    if (p.onEnter) p.onEnter();
                }
            } else if (p.collision.active === true) {
                p.collision.active = false;
                if (p.onLeave) p.onLeave();
            }
        }
    });
    // Play sound if player is touching the bounds
    if ($a4a249b17eda019f$export$ed594bb491455ccb) $033227655e61e1ba$var$contactingBoundsSound?.fadeTo(0, 0);
    else $033227655e61e1ba$var$contactingBoundsSound?.fadeTo(0, -90);
}
function $033227655e61e1ba$var$startWanderers() {
    const wanderers = $033227655e61e1ba$export$8061040b42890c32.filter((p)=>p.wander);
    wanderers.forEach((p)=>{
        $033227655e61e1ba$var$createNextWandererTween(p, 1);
    });
}
function $033227655e61e1ba$var$createNextWandererTween(p, i) {
    const time = Math.sqrt((p.position.x - p.wander.points[i].x) ** 2 + (p.position.y - p.wander.points[i].y) ** 2) / p.wander.points[i].s;
    new (0, $555be16020503cc9$export$208a41d6b4e37b97)(p.position, p.wander.points[i], time, "linear", (v)=>{
        p.sound.panner.positionPanner(v.x, v.z, v.y);
    }, (tween)=>{
        tween.dispose();
        let nextIndex;
        switch(p.wander.mode){
            case "loop":
                nextIndex = (i + 1) % p.wander.points.length;
                break;
            case "once":
                if (i === p.wander.points.length - 1) return;
                nextIndex = (i + 1) % p.wander.points.length;
                break;
            case "pingpong":
                if (i === p.wander.points.length - 1) p.wander.backwards = true;
                if (i === 0) p.wander.backwards = false;
                nextIndex = p.wander.backwards ? i - 1 : i + 1;
                break;
        }
        if (p.wander.pause) p.wander.pause(()=>$033227655e61e1ba$var$createNextWandererTween(p, nextIndex));
        else $033227655e61e1ba$var$createNextWandererTween(p, nextIndex);
    });
}









let $2a76fba06674b7fe$var$canvas;
let $2a76fba06674b7fe$var$ratio;
let $2a76fba06674b7fe$var$pixelsPerMeter;
function $2a76fba06674b7fe$export$2cd8252107eb640b() {
    $2a76fba06674b7fe$var$ratio = $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.width / $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.height;
    $2a76fba06674b7fe$var$pixelsPerMeter = $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width / $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.width;
    $2a76fba06674b7fe$var$canvas = document.createElement("canvas");
    $2a76fba06674b7fe$var$canvas.className = "map";
    $2a76fba06674b7fe$var$canvas.width = $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.width;
    $2a76fba06674b7fe$var$canvas.height = $9d5590b0ab76c0ef$export$e506a1d27d1eaa20.height * 1 / $2a76fba06674b7fe$var$ratio;
}
function $2a76fba06674b7fe$export$f80a6900d44a74ee() {
    return $2a76fba06674b7fe$var$canvas;
}
function $2a76fba06674b7fe$export$e529deb2bfd496dc() {
    // Draw the map
    const ctx = $2a76fba06674b7fe$var$canvas.getContext("2d");
    // Clear the canvas
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, $2a76fba06674b7fe$var$canvas.width, $2a76fba06674b7fe$var$canvas.height);
    // Draw the point field
    // TODO: Think and move compass.config.pointSeparation and compass.config.pixelsPerMeter to scene ?
    const pointsInterval = $2a76fba06674b7fe$var$canvas.width / $033227655e61e1ba$export$e506a1d27d1eaa20.worldSize.width * $f54ee5273209d384$export$e506a1d27d1eaa20.pointSeparation;
    ctx.fillStyle = "#222";
    for(let x = 0; x <= $2a76fba06674b7fe$var$canvas.width; x += pointsInterval)for(let y = 0; y <= $2a76fba06674b7fe$var$canvas.height; y += pointsInterval)ctx.fillRect(x - 0.75, y - 0.75, 1.5, 1.5);
    // TODO: review the transforms here and apply same strategy to compass draws + try to generalize draws ?
    ctx.save();
    ctx.translate($033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.x * $2a76fba06674b7fe$var$pixelsPerMeter, $033227655e61e1ba$export$e506a1d27d1eaa20.worldOrigin.y * $2a76fba06674b7fe$var$pixelsPerMeter);
    $2a76fba06674b7fe$var$drawPOIs(ctx);
    $2a76fba06674b7fe$var$drawPlayer(ctx);
    ctx.restore();
// TODO: drawFogOfWar(ctx);
}
function $2a76fba06674b7fe$var$drawPlayer(ctx) {
    const playerX = $a4a249b17eda019f$export$5880b8b5730aff45.x * $2a76fba06674b7fe$var$pixelsPerMeter;
    const playerY = $a4a249b17eda019f$export$5880b8b5730aff45.y * $2a76fba06674b7fe$var$pixelsPerMeter;
    // Add translate and rotate to the transformation matrix for world coordinates
    // TODO: convert all other draws with initial transforms then local coordinates like this method
    ctx.save();
    ctx.translate(playerX, playerY);
    ctx.rotate((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)($a4a249b17eda019f$export$9fddb9d0dd7d8a54));
    // Draw player
    ctx.beginPath();
    ctx.arc(0, 12, 8, (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45), (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) + (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45));
    ctx.lineTo(0, -8);
    ctx.closePath();
    ctx.fillStyle = "white";
    ctx.fill();
    // Restore transformation matrix to canvas coordinates
    ctx.restore();
}
function $2a76fba06674b7fe$var$drawPOIs(ctx) {
    const compassToMapRatio = $2a76fba06674b7fe$var$pixelsPerMeter / $f54ee5273209d384$export$e506a1d27d1eaa20.pixelsPerMeter;
    // TODO: filter out POIs that are still in fog of war
    const visiblePOIs = $033227655e61e1ba$export$8061040b42890c32.filter((p)=>!p.invisible);
    for (const p of visiblePOIs){
        if (p.hideOnMap) continue;
        const poiX = p.position.x * $2a76fba06674b7fe$var$pixelsPerMeter;
        const poiY = p.position.y * $2a76fba06674b7fe$var$pixelsPerMeter;
        ctx.save();
        ctx.translate(poiX, poiY);
        ctx.rotate((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(p.rotation));
        ctx.scale(compassToMapRatio, compassToMapRatio);
        if (p.symbolic !== false) ctx.scale(2, 2); // Make it a bit bigger for the map
        ctx.fillStyle = p.color;
        ctx.beginPath();
        if (p.image) {
            // Draw image
            const imageWidth = $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].width;
            const imageHeight = $14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image].height;
            ctx.drawImage($14a6d3d86d620d4f$export$6c746a5570b8b35c[p.image], -imageWidth / 2, -imageHeight / 2, imageWidth, imageHeight);
        } else if (p.type === "triangle") {
            // Draw a triangle centered on p.position
            ctx.beginPath();
            ctx.moveTo(Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(150)) * p.radius, Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(150)) * p.radius);
            ctx.lineTo(0, -p.radius);
            ctx.lineTo(Math.cos((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(30)) * p.radius, Math.sin((0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(30)) * p.radius);
            ctx.closePath();
        } else if (p.type === "circle" || !p.type) // Draw circle (default type)
        ctx.arc(0, 0, p.radius || 5, 0, Math.PI * 2);
        // Handling for styled shapes
        if (!p.image) {
            if (!p.style) ctx.fill();
            else if (p.style === "idle") {
                ctx.fillStyle = "#99b";
                ctx.strokeStyle = "#99b";
                ctx.lineWidth = 1;
                ctx.fill();
                ctx.stroke();
            } else if (p.style === "active") {
                const timebase = Math.abs(Math.sin(Math.floor(Date.now() / 3 % 1000) / 1000 * Math.PI * 2));
                ctx.strokeStyle = p.color.replace("50%", `${timebase * 30 + 50}%`);
                ctx.lineWidth = 2;
                ctx.fill();
                ctx.stroke();
            }
        }
        ctx.restore();
    }
    // Draw Grudge path points as question marks
    const grudge = $033227655e61e1ba$export$8061040b42890c32.find((p)=>p.name === "grudge");
    for (const point of grudge.wander.points){
        ctx.save();
        ctx.translate(point.x * $2a76fba06674b7fe$var$pixelsPerMeter, point.y * $2a76fba06674b7fe$var$pixelsPerMeter);
        ctx.font = "15px Helvetica Neue";
        ctx.fillStyle = "#666";
        ctx.fillText("?", 0, 0);
        ctx.restore();
    }
}



let $59d2451d2093640d$var$activeModal = null;
function $59d2451d2093640d$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector("#menu").classList.add("hidden");
        document.querySelector("main").classList.remove("hidden");
        $85faba1dc2985ba6$export$fbb4d68fe60c1629().then(()=>{
            $033227655e61e1ba$export$b3571188c770cc5a();
        });
        $9d5590b0ab76c0ef$export$f9ef67375ddc185();
    });
    document.querySelector(".js-close").addEventListener("click", (event)=>{
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $59d2451d2093640d$var$activeModal = null;
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = true;
    });
    document.querySelector(".modal-wrapper").addEventListener("click", (event)=>{
        if (event.target !== event.currentTarget) return;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $59d2451d2093640d$var$activeModal = null;
    });
}
function $59d2451d2093640d$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.style.display = "none";
    statusEl.innerText = status;
}
function $59d2451d2093640d$export$978857af675b1906() {
    document.querySelector("#menu").classList.remove("hidden");
    $59d2451d2093640d$export$471f7ae5c4103ae1(null);
}
function $59d2451d2093640d$export$787f5d117f138d13(text, title = null) {
    if ($59d2451d2093640d$var$activeModal !== "message") {
        $59d2451d2093640d$var$activeModal = "message";
        document.querySelector(".modal-content").innerHTML = `
            <h2 class="title">${title}</h2>
            <p class="message">${text}</p>
        `.trim();
        document.querySelector(".modal-wrapper").classList.remove("hidden");
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = false;
    } else {
        $59d2451d2093640d$var$activeModal = null;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = true;
    }
}
function $59d2451d2093640d$export$c448526daa762015() {
    if ($59d2451d2093640d$var$activeModal !== "map") {
        $59d2451d2093640d$var$activeModal = "map";
        const modal = document.querySelector(".modal-content");
        modal.innerHTML = `
            <p>Carte</p>
        `.trim();
        modal.appendChild($2a76fba06674b7fe$export$f80a6900d44a74ee());
        $2a76fba06674b7fe$export$e529deb2bfd496dc();
        document.querySelector(".modal-wrapper").classList.remove("hidden");
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = false;
    } else {
        $59d2451d2093640d$var$activeModal = null;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $a4a249b17eda019f$export$e506a1d27d1eaa20.controllable = true;
    }
}





const $f07678ac589b406d$var$keys = {};
let $f07678ac589b406d$var$hotKeysEnabled = false;
function $f07678ac589b406d$export$2cd8252107eb640b() {
    document.addEventListener("keydown", (e)=>{
        if (e.repeat) return;
        if (DEVMODE) console.log("Key down:", e.key);
        $f07678ac589b406d$var$keys[e.key] = true;
        if (!$f07678ac589b406d$var$hotKeysEnabled) return;
        switch(e.key){
            case "m":
                $59d2451d2093640d$export$c448526daa762015();
                break;
        }
        // FIXME: Debug only
        if (DEVMODE) {
            if ([
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8"
            ].includes(e.key)) $2cb597b4d1b272ca$export$663103110d94aac9(`stonehenge-triangle-${e.key}`, $a4a249b17eda019f$export$5880b8b5730aff45, {
                offset: {
                    x: 1,
                    y: 1
                }
            });
            if (e.key === "0") {
                $2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-1");
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-2"), 100);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-3"), 200);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-4"), 300);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-5"), 400);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-6"), 500);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-7"), 600);
                setTimeout(()=>$2cb597b4d1b272ca$export$2dabce2e5d7031d0("stonehenge-triangle-8"), 700);
            }
            switch(e.key){
                case "z":
                    $f54ee5273209d384$export$bdcc994deaedab19();
                    break;
                case "p":
                    $f54ee5273209d384$export$a66bf038d7620ad7();
                    break;
            }
        }
    });
    document.addEventListener("keyup", (e)=>{
        $f07678ac589b406d$var$keys[e.key] = false;
    });
}
function $f07678ac589b406d$export$d081dc64f99d208b(key) {
    return !!$f07678ac589b406d$var$keys[key];
}
function $f07678ac589b406d$export$3274927b96bdf2f0(bool = true) {
    $f07678ac589b406d$var$hotKeysEnabled = bool;
}







function $ec6c59466fda7acc$export$e529deb2bfd496dc() {
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).font = "400 14px Dosis";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillText(`${Math.abs($a4a249b17eda019f$export$5880b8b5730aff45.y.toFixed(1))} m ${$a4a249b17eda019f$export$5880b8b5730aff45.y <= 0 ? "N" : "S"}`, 20, (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).height - 20);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillText(`${Math.abs($a4a249b17eda019f$export$5880b8b5730aff45.x.toFixed(1))} m ${$a4a249b17eda019f$export$5880b8b5730aff45.x >= 0 ? "E" : "O"}`, 20, (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).height - 35);
}






const $52d0e1050c09c002$var$clickableAreas = [];
let $52d0e1050c09c002$var$hovering = false;
const $52d0e1050c09c002$var$clickCoordinates = {};
function $52d0e1050c09c002$export$2cd8252107eb640b() {
    const canvasElement = document.querySelector("canvas");
    canvasElement.addEventListener("click", (e)=>{
        $52d0e1050c09c002$var$clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        $52d0e1050c09c002$var$clickCoordinates.y = e.clientY - canvasElement.offsetTop;
        $52d0e1050c09c002$var$clickableAreas.forEach((area)=>{
            if ($52d0e1050c09c002$var$clickCoordinates.x >= area.x && $52d0e1050c09c002$var$clickCoordinates.x <= area.x + area.width && $52d0e1050c09c002$var$clickCoordinates.y >= area.y && $52d0e1050c09c002$var$clickCoordinates.y <= area.y + area.height) area.action();
        });
    });
    canvasElement.addEventListener("mousemove", (e)=>{
        $52d0e1050c09c002$var$clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        $52d0e1050c09c002$var$clickCoordinates.y = e.clientY - canvasElement.offsetTop;
        $52d0e1050c09c002$var$hovering = false;
        $52d0e1050c09c002$var$clickableAreas.forEach((area)=>{
            if ($52d0e1050c09c002$var$clickCoordinates.x >= area.x && $52d0e1050c09c002$var$clickCoordinates.x <= area.x + area.width && $52d0e1050c09c002$var$clickCoordinates.y >= area.y && $52d0e1050c09c002$var$clickCoordinates.y <= area.y + area.height) $52d0e1050c09c002$var$hovering = true;
        });
        canvasElement.style.cursor = $52d0e1050c09c002$var$hovering ? "pointer" : "default";
    });
}
function $52d0e1050c09c002$export$ab34af9df4770788(area) {
    $52d0e1050c09c002$var$clickableAreas.push(area);
}




function $69b5e5dbe1845423$export$2cd8252107eb640b() {
    // Add mode toggle clickable area
    $52d0e1050c09c002$export$ab34af9df4770788({
        x: (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 45,
        y: 15,
        width: 30,
        height: 30,
        action: ()=>{
            $f54ee5273209d384$export$ba03f2a005091f3b();
        }
    });
}
function $69b5e5dbe1845423$export$e529deb2bfd496dc() {
    // Draw mode toggle circle
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "#666";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 2;
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 30, 30, 15, 0, Math.PI * 2);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "#ccc";
    if ($f54ee5273209d384$export$1fc0f6205829e19c() === "heading-up") {
        // Draw heading icon
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 30, 42, 8, (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) - (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45), (0, $746fd1397863c828$export$1ad3c7ead57ef8c)(0) + (0, $746fd1397863c828$export$e6bfdeff8bfc94f9)(45));
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 30, 22);
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).closePath();
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
    } else {
        // Draw up indicator
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).moveTo((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 26, 23);
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 30, 19);
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineTo((0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 34, 23);
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill();
        // Draw north letter
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).font = "14px Helvetica Neue";
        (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillText("N", (0, $9d5590b0ab76c0ef$export$e506a1d27d1eaa20).width - 35, 37);
    }
}





function $93096094a50ae95c$export$2cd8252107eb640b() {
    // Add mode toggle clickable area
    $52d0e1050c09c002$export$ab34af9df4770788({
        x: 15,
        y: 15,
        width: 30,
        height: 30,
        action: ()=>{
            $59d2451d2093640d$export$c448526daa762015();
        }
    });
}
function $93096094a50ae95c$export$e529deb2bfd496dc() {
    // Draw mode toggle circle
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).strokeStyle = "#666";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).lineWidth = 2;
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).beginPath();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).arc(30, 30, 15, 0, Math.PI * 2);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).stroke();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fillStyle = "#ccc";
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).save();
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).translate(19.5, 19.5);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).scale(18 / 512, 18 / 512);
    // From https://fontawesome.com/icons/user-astronaut?f=classic&s=solid
    const path = new Path2D("M376 120c0 7.4-2.7 19-9.4 35c-6.5 15.4-15.7 32.4-26.4 49.7c-17.1 27.8-36.9 54.7-52.2 74.4c-15.3-19.7-35.1-46.6-52.2-74.4c-10.7-17.3-19.9-34.3-26.4-49.7c-6.7-15.9-9.4-27.6-9.4-35c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6V421.2L416 472.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V474.8L192 419.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V421.2L32 472.4V218.8l115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4V484.2c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3V155.8c0-17-17.1-28.6-32.9-22.3L425.2 180.7c-6.1 14.2-13.6 28.8-21.8 42.9z");
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).fill(path);
    (0, $c377ec5d5135246a$export$39f92e86d1722f3a).restore();
}


function $b36b9fdd7f118166$export$2cd8252107eb640b() {
    $f54ee5273209d384$export$2cd8252107eb640b();
    $69b5e5dbe1845423$export$2cd8252107eb640b();
    $93096094a50ae95c$export$2cd8252107eb640b();
}
function $b36b9fdd7f118166$export$722fbec263ad908a() {
    $f54ee5273209d384$export$722fbec263ad908a();
}
function $b36b9fdd7f118166$export$e529deb2bfd496dc() {
    $f54ee5273209d384$export$e529deb2bfd496dc();
    $ec6c59466fda7acc$export$e529deb2bfd496dc();
    $69b5e5dbe1845423$export$e529deb2bfd496dc();
    $93096094a50ae95c$export$e529deb2bfd496dc();
}










window.DEVMODE = true;
// Constants
const $9d5590b0ab76c0ef$export$e506a1d27d1eaa20 = {
    width: 500,
    height: 500
};
// Variables
let $9d5590b0ab76c0ef$var$timeOfLastFrame = 0;
function $9d5590b0ab76c0ef$var$init() {
    $59d2451d2093640d$export$2cd8252107eb640b();
    $59d2451d2093640d$export$471f7ae5c4103ae1("Initializing...");
    $c377ec5d5135246a$export$2cd8252107eb640b();
    $f07678ac589b406d$export$2cd8252107eb640b();
    $294c1e0055589ac6$export$2cd8252107eb640b();
    $52d0e1050c09c002$export$2cd8252107eb640b();
    $85faba1dc2985ba6$export$2cd8252107eb640b();
    $b36b9fdd7f118166$export$2cd8252107eb640b();
    $2a76fba06674b7fe$export$2cd8252107eb640b();
    $59d2451d2093640d$export$471f7ae5c4103ae1("Loading...");
    $033227655e61e1ba$export$2cd8252107eb640b().then(()=>{
        $59d2451d2093640d$export$978857af675b1906();
    }).catch(()=>{
        $59d2451d2093640d$export$471f7ae5c4103ae1("Error while loading scene...");
    });
}
function $9d5590b0ab76c0ef$export$f9ef67375ddc185(time = 0) {
    const dt = (time - $9d5590b0ab76c0ef$var$timeOfLastFrame) / 1000;
    $9d5590b0ab76c0ef$var$update(dt);
    $9d5590b0ab76c0ef$var$draw();
    $9d5590b0ab76c0ef$var$timeOfLastFrame = time;
    requestAnimationFrame($9d5590b0ab76c0ef$export$f9ef67375ddc185);
}
function $9d5590b0ab76c0ef$var$update(dt) {
    $555be16020503cc9$export$722fbec263ad908a(dt);
    $a4a249b17eda019f$export$722fbec263ad908a(dt);
    $033227655e61e1ba$export$722fbec263ad908a();
    $b36b9fdd7f118166$export$722fbec263ad908a();
}
function $9d5590b0ab76c0ef$var$draw() {
    $c377ec5d5135246a$export$42ffd38884aecdac();
    $b36b9fdd7f118166$export$e529deb2bfd496dc();
}
$9d5590b0ab76c0ef$var$init();


//# sourceMappingURL=index.40ec544d.js.map
